import { useState } from 'react';
import { notify } from '@/components';
import { CreateTaskGroupModal } from './CreateTaskGroupModal';
import { CreateTaskGroupArgs, useAddTaskGroupMutation } from '@/redux';

export function useGroupTasksAction(onSubmitted: () => void) {
  const [taskIds, setId] = useState<string[]>();
  const [projectId, setProjectId] = useState<string>();
  const [add] = useAddTaskGroupMutation();

  const reset = () => {
    setId(undefined);
    setProjectId(undefined);
  };

  const handleSubmit = (value: CreateTaskGroupArgs) => {
    add(value)
      .unwrap()
      .then(() => {
        notify.success.t('tasks.groups.added');
        reset();
      })
      .then(() => onSubmitted());
  };

  return {
    openCreateGroup: (taskIds: string[], projectId: string) => {
      setId(taskIds);
      setProjectId(projectId);
    },
    groupTaskModal: (
      <>
        {taskIds && projectId && (
          <CreateTaskGroupModal
            onSubmit={handleSubmit}
            taskIds={taskIds}
            projectId={projectId}
            onClose={reset}
          />
        )}
      </>
    ),
  };
}
